<template>
  <div>
    <Topnav />
    <v-row>
      <v-col
        v-if="leftNavbar"
        cols="12"
        md="2"
      >
        <Leftnav />
      </v-col>
      <v-col
        class="container-fluid pr-12"
        cols="12"
        md=""
      >
        <br>
        <br>
        <v-card
            class="pa-3"
            elevation="6"
          >
            <template>
              <v-data-table
                :headers="headers"
                :items="indexItems"
                :search="search"
                sort-by="calories"
              >
                <template v-slot:top>
                  <v-toolbar class="mb-3 pt-2" flat color="white">
                    <v-toolbar-title class="font-weight-bold">{{ tableTitle }}</v-toolbar-title>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    ></v-divider>
                    <v-toolbar-title>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="检 索 ..."
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-toolbar-title>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="500px">
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark rounded v-on="on">
                          <v-icon>mdi-plus</v-icon>
                          添加 {{ addIdentity }}
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline mb-6">{{ dialogTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="editedItem.username" label="用户名（必填）" reqiured></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="editedItem.password" label="密 码（必填）" reqiured></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="editedItem.job_number" label="工 号" reqiured></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-select
                                  v-model="editedItem.department" 
                                  :items="departmentItems"
                                  label="销售区域（必填）"
                                  reqiured
                                ></v-select>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-select
                                  v-model="editedItem.position" 
                                  :items="positionItems"
                                  label="销售 / 客户（必填）"
                                  reqiured
                                ></v-select>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-select
                                  v-model="editedItem.superior" 
                                  :items="superiorItems"
                                  label="归属销售（必填）"
                                  reqiured
                                ></v-select>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="editedItem.email" label="电子邮箱"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="editedItem.phone" label="联系电话"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" text @click="close">
                            取 消
                          </v-btn>
                          <v-btn color="primary" @click="save">
                            保 存
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                  <br>
                  <v-divider></v-divider>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <template v-slot:no-data>
                  <div>没有 销售人员/客户</div>
                </template>
              </v-data-table>
            </template>
          </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import Topnav from '@/components/TopNavbar.vue'
import Leftnav from '@/components/LeftNavbar.vue'
import Common from '@/components/common.vue'

export default {
  name: 'PersonnelSaleTable',
  components: {
    Topnav,
    Leftnav
  },
  data: () => ({
    leftNavbar: false,
    indexURL: Common.baseURL + 'user/index?department=sales',
    addURL: Common.baseURL + 'user/new',
    editURL: Common.baseURL + 'user/edit',
    deleteURL: Common.baseURL + 'user/delete',
    dialog: false,
    tableTitle: '销售部门 / 人员列表',
    dialogTitle: '销售部门 / 人员信息',
    addIdentity: '销售人员/客户',
    indexID: 'sale',
    departmentItems: [
      '华东',
      '华西',
      '华南',
      '华北'
    ],
    positionItems: [
      '经理',
      '销售',
      '客户'
    ],
    superiorItems: [],
    search: '',
    headers: [
      { text: '编 号', value: 'number' },
      { text: '用户名', value: 'username' },
      { text: '工 号', value: 'job_number' },
      { text: '销售区域', value: 'department' },
      { text: '职 位 / 客 户', value: 'position' },
      { text: '客户所属销售', value: 'superior' },
      { text: '电子邮箱', value: 'email' },
      { text: '联系电话', value: 'phone' },
      { text: '操 作', align: 'right', value: 'actions', sortable: false },
    ],
    indexItems: [],
    editedIndex: -1,
    editedItem: {
      username: '',
      password: '',
      job_number: '',
      department: '',
      position: '',
      superior: '',
      email: '',
      phone: ''
    },
    defaultItem: {
      username: '',
      password: '',
      job_number: '',
      department: '',
      position: '',
      superior: '',
      email: '',
      phone: ''
    },
  }),

  computed: {
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.userRole = sessionStorage.getItem('role')
      if (this.userRole == undefined) {
        console.log('need to login');
      }
      else if (this.userRole.indexOf('admin') != -1) {
        this.leftNavbar = true
      }
      axios.get(this.indexURL)
        .then(response => {
          console.log(response);
          for (var key in response.data) {
            this.indexItems.push(response.data[key])
            this.superiorItems.push(response.data[key]['username'])
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    editItem (item) {
      this.editedIndex = this.indexItems.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.indexItems.indexOf(item)
      confirm('是否确认删除销售或客户?') && axios.post(this.deleteURL, {
          _id: this.indexItems[index]['_id']
        })
        .then(response => {
          console.log(response.status);
        })
        .catch(function (error) {
          console.log(error);
        }) && this.indexItems.splice(index, 1)
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        axios.post(this.editURL, {
            editedItem: this.editedItem
          })
          .then(response => {
            console.log(response.status);
            Object.assign(this.indexItems[this.editedIndex], this.editedItem)
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        axios.post(this.addURL, {
            editedItem: this.editedItem
          })
          .then(response => {
            console.log(response.status);
            this.indexItems.push(response.data)
          })
          .catch(function (error) {
            console.log(error);
          });
      }
      this.close()
    },
  },
}
</script>